var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('vueTopprogress',{ref:"progress",attrs:{"color":"#4385f3","color-shadow":"transparent","error-color":"#fff"}}),(_vm.blocked)?_c('div',{staticClass:"blocker"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }